import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
//
import { Grid, Paper, Typography } from "@/components";
import { useResizeObserver, useSettings } from "@/hooks";
import { base64ToText } from "@/utils/base64";
//
import { StyledAvatar, StyledBox, StyledInfo } from "./style";
import environment from "@/enviroments/enviroment";
import shopMapping from "../../../library/shopMapping";

const defaultOptions = {
  message: "Olá, precisa de ajuda?",
};

const Dashboard = () => {
  const [{ assistantName }] = useSettings(["APP_ASSISTANT_NAME:assistantName"]);
  const currentRef = useResizeObserver();
  const navigate = useNavigate();
  const location = useLocation();
  const [expand, setExpand] = useState(false);

  const settings = useMemo(() => {
    const fragment = location.hash.replace("#", "");
    const options = fragment ? JSON.parse(base64ToText(fragment)) : {};

    return {
      ...defaultOptions,
      ...options,
    };
  }, [location]);

  const handleAction = () => {
    // Solicita imediatamente o tamanho expandido ao parent
    try {
      if (window.parent) {
        window.parent.postMessage(
          { type: "_CHAT_MAXIMIZE" },
          "*",
        );
      }
    } catch (_) { }

    const stored = sessionStorage.getItem("chat:channelId");

    // Tenta resolver ID pelo mapping/env
    let resolvedId = null;
    try {
      const search = new URLSearchParams(window.location.search);
      const keyFromQuery =
        search.get("empreendimento") || search.get("shop") || search.get("enterprise");

      let shopKey = keyFromQuery;
      if (!shopKey) {
        const keys = Object.keys(shopMapping || {});
        if (keys.length === 1) {
          shopKey = keys[0];
        }
      }

      const envVarName = shopKey ? shopMapping?.[shopKey] : null;
      const envValue = envVarName ? environment?.[envVarName] : null;

      if (typeof envValue === "string" && envValue.length > 0) {
        resolvedId = envValue;
      }

      console.info("Dashboard.navigate - mapping:", {
        shopKey,
        envVarName,
        hasEnvValue: Boolean(envValue),
      });
    } catch (err) {
      console.warn("Dashboard.navigate - erro ao resolver ID:", err);
    }

    const finalId = stored || resolvedId;
    const path = finalId ? `/chat/${finalId}` : "/";
    if (!finalId) {
      console.warn("Dashboard.navigate - ID não encontrado; navegando para /chat (fallback)");
    }
    navigate({ pathname: path, hash: location.hash || "" });
  };

  useEffect(() => {
    setExpand(true);
  }, []);

  return (
    <StyledBox
      ref={currentRef}
      className="presentation-box"
      expand={expand.toString()}
    >
      <Grid container spacing={1} alignItems="center">
        <Grid>
          <StyledInfo onClick={handleAction}>
            <Typography variant="body">{settings.message}</Typography>
          </StyledInfo>
        </Grid>
        <Grid>
          <StyledAvatar
            component={Paper}
            alt={assistantName}
            src="/static/images/avatar/1_cut.png"
            onClick={handleAction}
          />
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export default Dashboard;
